var _path, _path2, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56.705 51.36",
    height: 194.117,
    width: 214.318,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 9.494h11.678V.016H0Z",
    style: {
      strokeWidth: 0.264583
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      fillRule: "evenodd"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ed303b",
    d: "M44.01 34.156h12.152V.005h-12.15v34.154ZM27.89.005 20.022 31.83 12.156.003H.004l8.443 34.154H31.6L40.04.003H27.89z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd300",
    d: "M56.702 44.741a6.615 6.615 0 1 1-13.23 0 6.616 6.616 0 0 1 13.23 0"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    fill: "#ed303b",
    fontFamily: "Vi-SemiBold, Vi",
    fontSize: 2.995,
    fontWeight: 500,
    mask: "url(#a)",
    transform: "matrix(1.45163 0 0 1.45163 .004 -.73)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 39.839,
    y: 2.013
  }, "TM")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViLogo);
export default __webpack_public_path__ + "static/media/vi-logo.2fbc6a1d60bd61214f0ad3aa13469eb5.svg";
export { ForwardRef as ReactComponent };